import { ReactNode } from "react";
import { useTenancyAuth } from "@/context/TenancyAuthContext";
import { useNavigate } from "react-router";

export default function TenancyLayout({ children }: { children: ReactNode }) {
  const { tenancyUser, logout } = useTenancyAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/tenancy/login");
  };

  return (
    <div className="min-h-screen bg-[#f8f8f6] dark:bg-gray-950">
      {/* Top header elegante sin sidebar */}
      <header className="sticky top-0 z-40 w-full border-b border-black/[0.06] bg-white/80 backdrop-blur-xl dark:bg-gray-900/80 dark:border-white/10">
        <div className="mx-auto flex h-[64px] max-w-7xl items-center justify-between px-6 md:px-8">
          <div className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-black text-white dark:bg-white dark:text-black font-bold text-[15px]">
              T
            </div>
            <div>
              <p className="text-[14px] font-semibold tracking-tight text-gray-900 dark:text-white">
                Tenancy
              </p>
              <p className=" -mt-1 text-[11px] text-gray-500 dark:text-gray-400">
                Master Admin
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="hidden md:block text-right">
              <p className="text-[13px] font-medium text-gray-900 dark:text-white">
                {tenancyUser?.nombres}
              </p>
              <p className="text-[11px] text-gray-500">
                {tenancyUser?.correo_electronico}
              </p>
            </div>
            <button
              onClick={handleLogout}
              className="h-9 rounded-full border border-black/10 bg-white px-4 text-[13px] font-medium hover:bg-gray-50 dark:border-white/10 dark:bg-white/[0.06] dark:text-white dark:hover:bg-white/[0.10] transition"
            >
              Cerrar sesión
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-6 md:px-8 py-8 md:py-10">
        {children}
      </main>
    </div>
  );
}
